import { Component, computed, input, Input, InputSignal, OnInit, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';
import {
  AdPlacementRoadOccupationFormValue, occupationsToAdPlacementRoadOccupationFormValues
} from '../sections/ad-placement-section/forms/ad-placement-road-occupation.form';
import {
  AdPlacementOccupationPreviewComponent
} from '../sections/ad-placement-section/components/ad-placement-occupation-preview/ad-placement-occupation-preview.component';
import {
  PaymentsDataPreviewComponent
} from '../../common/payments-data-section/components/payments-data-preview/payments-data-preview.component';
import { ApplicationPayment } from '../../../../../services/application.common.model';
import { selectPayment } from '../../../../../store/selectors/application.selectors';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-placement-advertising-preview',
  standalone: true,
  imports: [
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    AgreementsDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    ContractorDataPreviewComponent,
    AdPlacementOccupationPreviewComponent,
    PaymentsDataPreviewComponent
  ],
  templateUrl: './placement-advertising-preview.component.html'
})
export class PlacementAdvertisingPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public payment: Signal<ApplicationPayment | null> = this.store$.selectSignal(selectPayment);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public roadOccupation: Signal<AdPlacementRoadOccupationFormValue | null> = computed(() => occupationsToAdPlacementRoadOccupationFormValues(this.application()).at(0) || null);

  constructor(
    private store$: Store
  ) {
  }

  public ngOnInit(): void {
  }
}
